import { jsx as l } from "react/jsx-runtime";
const t = (o) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    ...o,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        d: "m2.589 6.94 3.619-3.62 1.673.449L4.399 7.25H14.46l-.402 1.5H4.4l3.474 3.474-1.673.448L2.59 9.061 1.528 8l1.061-1.06Z"
      }
    )
  }
);
export {
  t as ArrowLeft
};
